import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pre-login',
  templateUrl: './pre-login.component.html',
  styleUrls: ['./pre-login.component.scss']
})
export class PreLoginComponent implements OnInit {

  form: UntypedFormGroup;

  constructor(
    fb: UntypedFormBuilder,
    private router: Router
  ) { 
    this.form = fb.group({
      password: [ null, Validators.required ]
    })
  }

  ngOnInit(): void {
  }

  submit() {

    if(this.form.valid) {

      const { password } = this.form.getRawValue();
      if(password === 'Ocd!@#19812') {
        localStorage.setItem('preLogin', 'true');
        this.router.navigate(['/']);
      } else {
        this.form.reset();
        alert('Senha errada!');
      }

    }

  }

}
